import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectRequestsGroupSearchQueryVariables = Types.Exact<{
  state?: Types.InputMaybe<Types.ProjectRequestsFilterState>;
  officeCode?: Types.InputMaybe<Types.Scalars['String']>;
  approver?: Types.InputMaybe<Types.Scalars['String']>;
  searchText?: Types.InputMaybe<Types.Scalars['String']>;
  token?: Types.InputMaybe<Types.Scalars['String']>;
  locationState?: Types.InputMaybe<Types.Scalars['String']>;
  customerNumber?: Types.InputMaybe<Types.Scalars['String']>;
  date?: Types.InputMaybe<Types.Scalars['LocalDate']>;
  projectManager?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ProjectRequestsGroupSearchQuery = { __typename?: 'QueryModel', projectRequests?: { __typename?: 'ProjectRequestQueryModel', groupSearch?: { __typename?: 'ConnectionOfProjectRequestGroup', token?: string | null, records?: Array<{ __typename?: 'ProjectRequestGroup', groupId: string, type: Types.GroupType, requests?: Array<{ __typename?: 'ProjectRequest', state: Types.ProjectRequestState, officeCode: string, scope: string, invoiceContact?: string | null, taxableServices: boolean, projectInstructions?: string | null, name: string, createdOn: any, fieldMeetInfo?: string | null, survey?: string | null, requestId: string, section?: string | null, clientContactName: string, block?: string | null, budget?: number | null, officeInstructions?: string | null, township?: string | null, governmentFunding: Types.GovernmentFundingType, rejectedReason?: string | null, afe?: string | null, range?: string | null, jobsFolderRequired: boolean, jobsFolderDriveLetter?: string | null, coGo?: string | null, fieldInstructions?: string | null, createdDate: string, statusMessage?: string | null, additionalComments?: string | null, fieldContact?: string | null, invoiceSubmitEmail?: string | null, lastCheckoutTime?: any | null, simplifiedName: string, projectOrigination?: Types.ProjectOrigination | null, projectOriginationName?: string | null, checkedOutBy?: { __typename?: 'Employee', userPrincipalName: string, firstName: string, middleInitial: string, lastName: string } | null, customer?: { __typename?: 'Customer', name: string, number?: string | null, status: Types.CustomerStatus } | null, approver?: { __typename?: 'Employee', userPrincipalName: string, firstName: string, middleInitial: string, lastName: string } | null, eogAfeType?: { __typename?: 'EogAfeType', gen: string, sub: string, description: string, afeType: string } | null, groupedFolder?: { __typename?: 'GroupedFolder', id: number, name: string, syncStatus: Types.SyncStatus } | null, location?: { __typename?: 'StateCounty', state: string } | null, projectManager?: { __typename?: 'Employee', userPrincipalName: string, firstName: string, middleInitial: string, lastName: string } | null, serviceDescription?: { __typename?: 'ServiceDescription', legacyWorkCode: string, displayName: string, isOverhead: boolean, projectType: string, description: string, industry: string } | null, requester?: { __typename?: 'Employee', userPrincipalName: string, firstName: string, middleInitial: string, lastName: string } | null } | null> | null } | null> | null } | null } | null };


export const ProjectRequestsGroupSearchDocument = gql`
    query ProjectRequestsGroupSearch($state: ProjectRequestsFilterState, $officeCode: String, $approver: String, $searchText: String, $token: String, $locationState: String, $customerNumber: String, $date: LocalDate, $projectManager: String) {
  projectRequests {
    groupSearch(
      state: $state
      officeCode: $officeCode
      approver: $approver
      searchText: $searchText
      token: $token
      locationState: $locationState
      customerNumber: $customerNumber
      date: $date
      projectManager: $projectManager
    ) {
      token
      records {
        groupId
        type
        requests {
          state
          officeCode
          scope
          invoiceContact
          taxableServices
          projectInstructions
          checkedOutBy {
            userPrincipalName
            firstName
            middleInitial
            lastName
          }
          customer {
            name
            number
            status
          }
          approver {
            userPrincipalName
            firstName
            middleInitial
            lastName
          }
          name
          createdOn
          fieldMeetInfo
          survey
          requestId
          section
          clientContactName
          block
          budget
          officeInstructions
          township
          governmentFunding
          rejectedReason
          afe
          eogAfeType {
            gen
            sub
            description
            afeType
          }
          range
          jobsFolderRequired
          jobsFolderDriveLetter
          groupedFolder {
            id
            name
            syncStatus
          }
          coGo
          fieldInstructions
          location {
            state
          }
          createdDate
          projectManager {
            userPrincipalName
            firstName
            middleInitial
            lastName
          }
          statusMessage
          additionalComments
          serviceDescription {
            legacyWorkCode
            displayName
            isOverhead
            projectType
            description
            industry
          }
          fieldContact
          requester {
            userPrincipalName
            firstName
            middleInitial
            lastName
          }
          invoiceSubmitEmail
          lastCheckoutTime
          simplifiedName
          projectOrigination
          projectOriginationName
        }
      }
    }
  }
}
    `;

/**
 * __useProjectRequestsGroupSearchQuery__
 *
 * To run a query within a React component, call `useProjectRequestsGroupSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestsGroupSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRequestsGroupSearchQuery({
 *   variables: {
 *      state: // value for 'state'
 *      officeCode: // value for 'officeCode'
 *      approver: // value for 'approver'
 *      searchText: // value for 'searchText'
 *      token: // value for 'token'
 *      locationState: // value for 'locationState'
 *      customerNumber: // value for 'customerNumber'
 *      date: // value for 'date'
 *      projectManager: // value for 'projectManager'
 *   },
 * });
 */
export function useProjectRequestsGroupSearchQuery(baseOptions?: Apollo.QueryHookOptions<ProjectRequestsGroupSearchQuery, ProjectRequestsGroupSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectRequestsGroupSearchQuery, ProjectRequestsGroupSearchQueryVariables>(ProjectRequestsGroupSearchDocument, options);
      }
export function useProjectRequestsGroupSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectRequestsGroupSearchQuery, ProjectRequestsGroupSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectRequestsGroupSearchQuery, ProjectRequestsGroupSearchQueryVariables>(ProjectRequestsGroupSearchDocument, options);
        }
export type ProjectRequestsGroupSearchQueryHookResult = ReturnType<typeof useProjectRequestsGroupSearchQuery>;
export type ProjectRequestsGroupSearchLazyQueryHookResult = ReturnType<typeof useProjectRequestsGroupSearchLazyQuery>;
export type ProjectRequestsGroupSearchQueryResult = Apollo.QueryResult<ProjectRequestsGroupSearchQuery, ProjectRequestsGroupSearchQueryVariables>;